import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody37';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy37 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Brand Landscaping </h2><h4>for a Destination Development Client</h4>";

  return (
    <>
        <Helmet>
        <title>Brand Landscaping for a Destination Development Client</title>
        <meta property="og:title" content="Brand Landscaping for a Destination Development Client" />
        <meta property='og:description' content='Brand Landscaping for a Destination Development Client'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy37" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy37 
